import { compose, lifecycle, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getPageLocation } from 'selectors'
import { getAllSelectedFilters } from '../selectors'
import { filterItems, resetFilters, setFiltersData, setCustomPriceRangeData, resetCustomPriceRangeData } from '../actions'
import { getPriceRangeFromSearch } from '../helpers'
import TireSearchGuidedNavigation from './TireSearchGuidedNavigation'
import isEqual from 'lodash/isEqual'

const withSearchStateUpdate = lifecycle({
  componentDidMount() {
    const { navigation, setFiltersData, customPriceRangeData, setCustomPriceRangeData } = this.props
    setFiltersData({ navigation })
    setCustomPriceRangeData(customPriceRangeData)
  },

  componentDidUpdate({ navigation: prevNavigation }) {
    const {
      navigation,
      setFiltersData,
      customPriceRangeData,
      setCustomPriceRangeData
    } = this.props

    if (!isEqual(prevNavigation, navigation)) {
      setFiltersData({ navigation })
      setCustomPriceRangeData(customPriceRangeData)
    }
  },

  componentWillUnmount() {
    this.props.resetCustomPriceRangeData()
  }
})

const mapStateToProps = (state, { totalNumRecs }) => ({
  selectedFilters: getAllSelectedFilters(state),
  customPriceRangeData: { ...getPriceRangeFromSearch({ search: getPageLocation(state).search }), count: totalNumRecs }
})

const withHideIfNoRecords = branch(({ totalNumRecs }) => !totalNumRecs,
  renderNothing
)

export default compose(
  withType({ type: 'TireSearchGuidedNavigation' }),
  connect(mapStateToProps, {
    filterItems,
    resetFilters,
    setFiltersData,
    resetCustomPriceRangeData,
    setCustomPriceRangeData
  }),
  withHideIfNoRecords,
  withSearchStateUpdate
)(TireSearchGuidedNavigation)
